module.exports = __webpack_public_path__ + "img/resort-2026.ed8e4657.png";